const calculateTotalTaxes = order => (
  order.items.reduce((to, item) =>
    to += item.taxItems.reduce((total, taxItem) =>
      total += taxItem.amount
      , 0
    )
    , 0
  )
)

export default calculateTotalTaxes